const windowWidth = document.documentElement ? document.documentElement.offsetWidth : window.innerWidth

const RATIO = windowWidth / 750


const DEFAULT_OPTIONS = {
    bottom_active: 40,
    scroll_padding_left: 0,
}

// bottom_active: 可以是 百分比（50%）或者 Number的形式
export const tabsScroll = (options = DEFAULT_OPTIONS) => {
    const { bottom_active, scroll_padding_left} = Object.assign({}, DEFAULT_OPTIONS, options)
    const bottom_active_percent = bottom_active.toString().indexOf("%") != -1
    const tab_bar_width = bottom_active_percent ? 0 : bottom_active * RATIO
    const tabs_padding_left = scroll_padding_left * RATIO
    return {
        data() {
            return {
                active_bar_left: 0,
                tab_selected: '',
                active_bar_width: tab_bar_width,
            }
        },
        created () {
            this.$watch(() => {
                return {
                    selected: this.selected,
                    scroll: this.scroll
                }
            }, ({ selected, scroll }) => {
                this.selectTab(scroll, selected)
            })
            this.selectTab(this.scroll, this.selected)
        },
        methods: {
            selectTab (scroll, selected) {
                if (!scroll) {
                    return
                }
                this.$nextTick(() => {
                    this.moveScrollView(selected)
                    this.moveTabBar(selected)
                })
            },
            onChange (e) {
                const { key, name, index } = e.currentTarget.dataset
                this.$emit('change', key, name, index)
            },
            getScrollLeft () {
                return new Promise((resovle) => {
                    resovle(document.querySelector('#scroll').scrollLeft)
                })
            },
            getTabInfo (tab) {
                console.error(`#tab-${tab}`)
                return new Promise(resovle => {
                    const { offsetLeft, offsetWidth } = document.querySelector(`#tab-${tab}`)
                    if (bottom_active_percent) {
                        this.active_bar_width = offsetWidth * (bottom_active.replace("%",""))/100
                    }
                    resovle({
                        left: offsetLeft,
                        width: offsetWidth
                    })
                })
            },
            moveTabBar (selected) {
                Promise.all([this.getScrollLeft(), this.getTabInfo(selected)]).then(([scrollLeft, { width, left } ]) => {
                    this.active_bar_left = left + scrollLeft + (width - this.active_bar_width) / 2 - tabs_padding_left
                })
            },
            moveScrollView (selected) {
                let index = ''
                this.tabs.forEach((element, i) => {
                    if (element.key === selected) index = i
                })
                index = index === 0 ? 0 : index - 1
                const select = this.tabs[index].key
                this.tab_selected = `tab-${select}`
                const $scroll = this.$el.querySelector('#scroll')
                const $active_el = $scroll.querySelector('#' + this.tab_selected)
                console.log($active_el.offsetLeft, $scroll.scrollLeft)
                if ($active_el) {
                    $scroll.scrollTo({
                        left: $active_el.offsetLeft - $scroll.scrollLeft - $scroll.offsetLeft
                    })
                }
            }
        },
        props: {
            scroll: {
                type: Boolean,
                default: true
            },
            width: {
                type: String
            },
            tabs: {
                type: Array,
                default: []
            },
            selected: {
                type: [ String, Number ]
            }
        },
    }
}
export default tabsScroll()